import axios from 'axios';
export function setBaseURL() {
   axios.defaults.baseURL = process.env.APP_API_URL
}

export function setIntercept(store, router) {
   axios.interceptors.response.use(null, (error) => {
      if (error.response.status == 401) {
         store.commit('logout');
         router.push('/login');
      }

      return Promise.reject(error);
   })
}